import FileForm from './FileForm'
export {FileForm}
export default FileForm
